export default __webpack_public_path__ + "static/media/Rotafolio_semillas.65c9af1b.pdf";